import { useEffect }from "react";

export interface FooterScriptProps {
    userIsLoggedIn : boolean;
}

export default function FooterScript() {
    /*
        wrap the inner content of useEffect in a if(userIsLoggedIn) when ready!
    */
    useEffect(() => {
        const script = document.createElement('script');
        const scriptText = document.createTextNode(
            `var _sid = '1916';
            (function() {
              var se = document.createElement('script'); se.type = 'text/javascript'; se.async = true;
              se.src = ('https:' == document.location.protocol ? 'https://' : 'http://') + 'files.imbox.io/app/dist/initWidget.js';
              var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(se, s);
            })();`
            );

        script.appendChild(scriptText);
        document.body.appendChild(script);
      
        return () => {
          document.body.removeChild(script);
        }
      }, []);

    return (
        null
    );
}
